function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
} return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect } from 'react';
import { Drawer, Box, Typography, IconButton, TextField, InputAdornment, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Button, Checkbox, Chip, Alert, Stack, Autocomplete } from '@mui/material';
import { Search as SearchIcon, DeleteOutlined as DeleteIcon, FilterListOutlined as FilterIcon } from '@mui/icons-material';
import Popper from '@mui/material/Popper';
import { UserAPI } from '../apis/UserAPI';
// Custom Popper for Autocomplete to fix alignment
var FullWidthPopper = function FullWidthPopper(props) {
    var _props$style;
    return /*#__PURE__*/ React.createElement(Popper, _extends({}, props, {
        style: _objectSpread(_objectSpread({
            width: (_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width,
            minWidth: 300
        }, props.style), {}, {
            left: 0
        }),
        placement: "bottom-start"
    }));
};
var UserGroupDrawer = function UserGroupDrawer(_ref) {
    var open = _ref.open, onClose = _ref.onClose, group = _ref.group, onDelete = _ref.onDelete, onMembersUpdated = _ref.onMembersUpdated;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), members = _useState2[0], setMembers = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), allUsers = _useState4[0], setAllUsers = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), selectedUsers = _useState6[0], setSelectedUsers = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), loading = _useState8[0], setLoading = _useState8[1];
    var _useState9 = useState(null), _useState0 = _slicedToArray(_useState9, 2), error = _useState0[0], setError = _useState0[1];
    var _useState1 = useState(false), _useState10 = _slicedToArray(_useState1, 2), autocompleteOpen = _useState10[0], setAutocompleteOpen = _useState10[1];
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), autocompleteLoading = _useState12[0], setAutocompleteLoading = _useState12[1];
    var _useState13 = useState([]), _useState14 = _slicedToArray(_useState13, 2), selectedMemberIds = _useState14[0], setSelectedMemberIds = _useState14[1];
    useEffect(function () {
        if (group && open) {
            loadMembers();
            loadAllUsers();
        }
    }, [group, open]);
    var loadMembers = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var response, transformedMembers, _err$response, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            if (group) {
                                _context.n = 1;
                                break;
                            }
                            return _context.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            _context.p = 2;
                            _context.n = 3;
                            return UserAPI.getUserGroupMembers(group.id.toString());
                        case 3:
                            response = _context.v;
                            transformedMembers = response.resource ? response.resource.map(function (member) {
                                var _member$userAttribute;
                                var firstName = member.first_name || '';
                                var lastName = member.last_name || '';
                                var name = ((_member$userAttribute = member.userAttributes) === null || _member$userAttribute === void 0 ? void 0 : _member$userAttribute.name) || '';
                                var email = member.email || member.username || '';
                                var initials = '';
                                if (firstName && lastName) {
                                    initials = "".concat(firstName[0]).concat(lastName[0]);
                                }
                                else if (name) {
                                    var _nameParts$0$, _nameParts$, _nameParts$at$, _nameParts$at;
                                    var nameParts = name.trim().split(/\s+/);
                                    var firstInitial = (_nameParts$0$ = (_nameParts$ = nameParts[0]) === null || _nameParts$ === void 0 ? void 0 : _nameParts$[0]) !== null && _nameParts$0$ !== void 0 ? _nameParts$0$ : '';
                                    var lastInitial = (_nameParts$at$ = (_nameParts$at = nameParts.at(-1)) === null || _nameParts$at === void 0 ? void 0 : _nameParts$at[0]) !== null && _nameParts$at$ !== void 0 ? _nameParts$at$ : '';
                                    initials = nameParts.length > 1 ? "".concat(firstInitial).concat(lastInitial) : name.substring(0, 2);
                                    initials = initials.toUpperCase();
                                }
                                else if (email) {
                                    initials = email.substring(0, 2).toUpperCase();
                                }
                                return {
                                    id: member.id,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: name,
                                    email: email,
                                    initials: initials
                                };
                            }) : [];
                            setMembers(transformedMembers);
                            _context.n = 5;
                            break;
                        case 4:
                            _context.p = 4;
                            _t = _context.v;
                            console.error('Failed to load members:', _t);
                            if ((_t === null || _t === void 0 || (_err$response = _t.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 404) {
                                setMembers([]);
                            }
                            else {
                                setError('Failed to load group members');
                            }
                        case 5:
                            _context.p = 5;
                            setLoading(false);
                            return _context.f(5);
                        case 6:
                            return _context.a(2);
                    }
            }, _callee, null, [[2, 4, 5, 6]]);
        }));
        return function loadMembers() {
            return _ref2.apply(this, arguments);
        };
    }();
    var loadAllUsers = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            var response, users, transformedUsers, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setAutocompleteLoading(true);
                            _context2.p = 1;
                            _context2.n = 2;
                            return UserAPI.getUsers();
                        case 2:
                            response = _context2.v;
                            users = response.resource || [];
                            transformedUsers = users.map(function (user) {
                                var _user$userAttributes;
                                var firstName = user.first_name || user.firstName || '';
                                var lastName = user.last_name || user.lastName || '';
                                var name = ((_user$userAttributes = user.userAttributes) === null || _user$userAttributes === void 0 ? void 0 : _user$userAttributes.name) || '';
                                var email = user.email || user.username || '';
                                var initials = '';
                                if (firstName && lastName) {
                                    initials = "".concat(firstName[0]).concat(lastName[0]);
                                }
                                else if (name) {
                                    var _nameParts$0$2, _nameParts$2, _nameParts$at$2, _nameParts$at2;
                                    var nameParts = name.trim().split(/\s+/);
                                    var firstInitial = (_nameParts$0$2 = (_nameParts$2 = nameParts[0]) === null || _nameParts$2 === void 0 ? void 0 : _nameParts$2[0]) !== null && _nameParts$0$2 !== void 0 ? _nameParts$0$2 : '';
                                    var lastInitial = (_nameParts$at$2 = (_nameParts$at2 = nameParts.at(-1)) === null || _nameParts$at2 === void 0 ? void 0 : _nameParts$at2[0]) !== null && _nameParts$at$2 !== void 0 ? _nameParts$at$2 : '';
                                    initials = nameParts.length > 1 ? "".concat(firstInitial).concat(lastInitial) : name.substring(0, 2);
                                    initials = initials.toUpperCase();
                                }
                                else if (email) {
                                    initials = email.substring(0, 2).toUpperCase();
                                }
                                return {
                                    id: user.id,
                                    firstName: firstName,
                                    lastName: lastName,
                                    name: name,
                                    email: email,
                                    initials: initials
                                };
                            });
                            setAllUsers(transformedUsers);
                            _context2.n = 4;
                            break;
                        case 3:
                            _context2.p = 3;
                            _t2 = _context2.v;
                            console.error('Failed to load users:', _t2);
                            setAllUsers([]);
                        case 4:
                            _context2.p = 4;
                            setAutocompleteLoading(false);
                            return _context2.f(4);
                        case 5:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 3, 4, 5]]);
        }));
        return function loadAllUsers() {
            return _ref3.apply(this, arguments);
        };
    }();
    var toggleMemberSelection = function toggleMemberSelection(memberId) {
        setSelectedMemberIds(function (prev) {
            return prev.includes(memberId) ? prev.filter(function (id) {
                return id !== memberId;
            }) : [].concat(_toConsumableArray(prev), [memberId]);
        });
    };
    var handleAddMembers = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _t3;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!(!group || selectedUsers.length === 0)) {
                                _context3.n = 1;
                                break;
                            }
                            return _context3.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            _context3.p = 2;
                            _context3.n = 3;
                            return UserAPI.addUsersToGroup(group.id.toString(), selectedUsers.map(function (u) {
                                return u.id;
                            }));
                        case 3:
                            setSelectedUsers([]);
                            _context3.n = 4;
                            return loadMembers();
                        case 4:
                            onMembersUpdated();
                            _context3.n = 6;
                            break;
                        case 5:
                            _context3.p = 5;
                            _t3 = _context3.v;
                            console.error('Failed to add members:', _t3);
                            setError('Failed to add members to group');
                        case 6:
                            _context3.p = 6;
                            setLoading(false);
                            return _context3.f(6);
                        case 7:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[2, 5, 6, 7]]);
        }));
        return function handleAddMembers() {
            return _ref4.apply(this, arguments);
        };
    }();
    var handleRemoveMember = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(userId) {
            var _t4;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.p = _context4.n) {
                        case 0:
                            if (group) {
                                _context4.n = 1;
                                break;
                            }
                            return _context4.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            _context4.p = 2;
                            _context4.n = 3;
                            return UserAPI.removeUsersFromGroup(group.id.toString(), [userId]);
                        case 3:
                            _context4.n = 4;
                            return loadMembers();
                        case 4:
                            onMembersUpdated();
                            _context4.n = 6;
                            break;
                        case 5:
                            _context4.p = 5;
                            _t4 = _context4.v;
                            console.error('Failed to remove member:', _t4);
                            setError('Failed to remove member from group');
                        case 6:
                            _context4.p = 6;
                            setLoading(false);
                            return _context4.f(6);
                        case 7:
                            return _context4.a(2);
                    }
            }, _callee4, null, [[2, 5, 6, 7]]);
        }));
        return function handleRemoveMember(_x) {
            return _ref5.apply(this, arguments);
        };
    }();
    var handleBulkRemoveMembers = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5() {
            var _t5;
            return _regenerator().w(function (_context5) {
                while (1)
                    switch (_context5.p = _context5.n) {
                        case 0:
                            if (!(!group || selectedMemberIds.length === 0)) {
                                _context5.n = 1;
                                break;
                            }
                            return _context5.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            _context5.p = 2;
                            _context5.n = 3;
                            return UserAPI.removeUsersFromGroup(group.id.toString(), selectedMemberIds);
                        case 3:
                            setSelectedMemberIds([]);
                            _context5.n = 4;
                            return loadMembers();
                        case 4:
                            onMembersUpdated();
                            _context5.n = 6;
                            break;
                        case 5:
                            _context5.p = 5;
                            _t5 = _context5.v;
                            console.error('Failed to bulk remove members:', _t5);
                            setError('Failed to remove selected members from group');
                        case 6:
                            _context5.p = 6;
                            setLoading(false);
                            return _context5.f(6);
                        case 7:
                            return _context5.a(2);
                    }
            }, _callee5, null, [[2, 5, 6, 7]]);
        }));
        return function handleBulkRemoveMembers() {
            return _ref6.apply(this, arguments);
        };
    }();
    if (!group)
        return null;
    return /*#__PURE__*/ React.createElement(Drawer, {
        anchor: "right",
        open: open,
        onClose: onClose,
        sx: {
            '& .MuiDrawer-paper': {
                width: 600,
                borderRadius: '24px 0 0 24px',
                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)'
            }
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 2,
            borderBottom: '1px solid #ebebeb',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        sx: {
            fontWeight: 600,
            fontSize: '20px'
        }
    }, group.name), /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function onClick() {
            if (selectedMemberIds.length > 0) {
                handleBulkRemoveMembers();
            }
            else {
                onDelete(group);
            }
        },
        disabled: loading || members.length > 0 && selectedMemberIds.length === 0,
        sx: {
            border: '1px solid #da291c',
            borderRadius: '2px',
            color: '#da291c',
            width: 40,
            height: 40,
            position: 'relative'
        },
        size: "small"
    }, /*#__PURE__*/ React.createElement(DeleteIcon, {
        fontSize: "small"
    }), selectedMemberIds.length > 0 && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            position: 'absolute',
            top: -8,
            right: -8,
            background: '#da291c',
            color: 'white',
            borderRadius: '50%',
            width: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 700,
            boxShadow: '0 0 0 2px white'
        }
    }, selectedMemberIds.length))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            flex: 1,
            p: 3,
            overflow: 'auto'
        }
    }, error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 2
        }
    }, error), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Autocomplete, {
        PopperComponent: FullWidthPopper,
        multiple: true,
        open: autocompleteOpen,
        onOpen: function onOpen() {
            return setAutocompleteOpen(true);
        },
        onClose: function onClose() {
            return setAutocompleteOpen(false);
        },
        value: selectedUsers,
        onChange: function onChange(event, newValue) {
            setSelectedUsers(newValue);
        },
        options: allUsers.filter(function (user) {
            return !members.some(function (m) {
                return m.id === user.id;
            });
        }),
        getOptionLabel: function getOptionLabel(option) {
            if (option.firstName || option.lastName) {
                return "".concat(option.lastName).concat(option.lastName && option.firstName ? ', ' : '').concat(option.firstName);
            }
            if (option.name) {
                return option.name;
            }
            return option.email;
        },
        loading: autocompleteLoading,
        disabled: loading,
        filterOptions: function filterOptions(options, state) {
            if (!state.inputValue)
                return options;
            var inputValue = state.inputValue.toLowerCase();
            return options.filter(function (option) {
                var _option$firstName, _option$lastName, _option$name, _option$email;
                return ((_option$firstName = option.firstName) === null || _option$firstName === void 0 ? void 0 : _option$firstName.toLowerCase().includes(inputValue)) || ((_option$lastName = option.lastName) === null || _option$lastName === void 0 ? void 0 : _option$lastName.toLowerCase().includes(inputValue)) || ((_option$name = option.name) === null || _option$name === void 0 ? void 0 : _option$name.toLowerCase().includes(inputValue)) || ((_option$email = option.email) === null || _option$email === void 0 ? void 0 : _option$email.toLowerCase().includes(inputValue));
            });
        },
        renderInput: function renderInput(params) {
            return /*#__PURE__*/ React.createElement(TextField, _extends({}, params, {
                placeholder: selectedUsers.length === 0 ? 'Invite members to this group by name or email' : '',
                InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
                    startAdornment: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }
                    }, /*#__PURE__*/ React.createElement(InputAdornment, {
                        position: "start",
                        sx: {
                            mr: 0.5,
                            ml: 0
                        }
                    }, /*#__PURE__*/ React.createElement(SearchIcon, {
                        sx: {
                            color: '#212121'
                        }
                    })), params.InputProps.startAdornment),
                    endAdornment: /*#__PURE__*/ React.createElement(Box, {
                        sx: {
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }
                    }, params.InputProps.endAdornment, selectedUsers.length > 0 && /*#__PURE__*/ React.createElement(Button, {
                        sx: {
                            bgcolor: '#26890d',
                            color: 'white',
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: '14px',
                            letterSpacing: '0.8px',
                            px: 2,
                            py: 0.75,
                            minWidth: 'auto',
                            '&:hover': {
                                bgcolor: '#1f6f0a'
                            }
                        },
                        onClick: handleAddMembers,
                        disabled: loading
                    }, "Add"))
                })
            }));
        },
        renderTags: function renderTags(value, getTagProps) {
            return value.map(function (option, index) {
                var hasName = option.firstName || option.lastName;
                var separator = option.lastName && option.firstName ? ', ' : '';
                var chipLabel = hasName ? "".concat(option.lastName).concat(separator).concat(option.firstName) : option.name || option.email;
                return /*#__PURE__*/ React.createElement(Chip, _extends({}, getTagProps({
                    index: index
                }), {
                    key: option.id,
                    label: chipLabel,
                    sx: {
                        bgcolor: 'white',
                        border: '1px solid #d9d9d9',
                        height: 28,
                        m: 0.25,
                        '& .MuiChip-label': {
                            fontSize: '12px',
                            fontWeight: 600,
                            px: 1
                        }
                    }
                }));
            });
        },
        sx: {
            '& .MuiAutocomplete-popupIndicator': {
                display: 'none'
            },
            '& .MuiAutocomplete-clearIndicator': {
                display: 'none'
            },
            '& .MuiOutlinedInput-root': {
                flexWrap: 'wrap',
                alignItems: 'center',
                padding: '8px 12px',
                paddingRight: selectedUsers.length > 0 ? '80px' : '12px',
                minHeight: 56,
                '& .MuiAutocomplete-input': {
                    minWidth: 200,
                    flexGrow: 1,
                    padding: '4px 0',
                    height: 'auto',
                    minHeight: 'unset'
                }
            },
            '& .MuiAutocomplete-endAdornment': {
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)'
            }
        }
    })), /*#__PURE__*/ React.createElement(TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 0.5
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        size: "small",
        checked: members.length > 0 && selectedMemberIds.length === members.length,
        indeterminate: selectedMemberIds.length > 0 && selectedMemberIds.length < members.length,
        onChange: function onChange(e) {
            if (e.target.checked) {
                setSelectedMemberIds(members.map(function (m) {
                    return m.id;
                }));
            }
            else {
                setSelectedMemberIds([]);
            }
        },
        sx: {
            color: '#d9d9d9',
            '&.Mui-checked': {
                color: '#26890d'
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, "Team members"), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1,
            width: 100
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, "Delete")))), /*#__PURE__*/ React.createElement(TableBody, null, members.length === 0 ? /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        colSpan: 2,
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#888"
    }, "No members in this group"))) : members.map(function (member, index) {
        return /*#__PURE__*/ React.createElement(TableRow, {
            key: member.id,
            sx: {
                borderTop: index > 0 ? '1px solid #ebebeb' : 'none'
            }
        }, /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: 'none',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            size: "small",
            checked: selectedMemberIds.includes(member.id),
            onChange: function onChange() {
                return toggleMemberSelection(member.id);
            },
            sx: {
                color: '#d9d9d9',
                '&.Mui-checked': {
                    color: '#26890d'
                }
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontSize: '14px'
            }
        }, member.firstName || member.lastName ? "".concat(member.firstName, " ").concat(member.lastName).trim() : member.name || member.email))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: 'none',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleRemoveMember(member.id);
            },
            disabled: loading,
            sx: {
                color: '#da291c',
                '&:hover': {
                    bgcolor: 'rgba(218, 41, 28, 0.04)'
                }
            },
            size: "small"
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            fontSize: "small"
        }))));
    }))))), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 2,
            borderTop: '1px solid #ebebeb',
            display: 'flex',
            justifyContent: 'flex-end'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        onClick: onClose,
        sx: {
            bgcolor: '#26890d',
            textTransform: 'none',
            boxShadow: 'none',
            fontWeight: 600,
            px: 3,
            '&:hover': {
                bgcolor: '#1f6f0a'
            }
        }
    }, "Close"))));
};
export default UserGroupDrawer;
